import React from "react";
import { DatePicker } from "antd";

const CommonDatePicker = ({ onChange, value }) => {
  return <DatePicker onChange={onChange} value={value} className="border focus:!border-primary hover:!border-primary" />;
};

export default CommonDatePicker;
